import React from 'react';
import { Card } from "react-bootstrap";
import { BsDot } from "react-icons/bs";
import { BsPersonCheck } from "react-icons/bs";
import { BsStarFill } from "react-icons/bs";
import { BsStar } from "react-icons/bs";


export default function DisplayReview(props) {

    const review = props.review;
    console.log(review);
    // const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    // const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const parsedStart = Date.parse(review.createdAt);
    const start = new Date(parsedStart);
    const date = start.getDate()+ '/' + (start.getMonth()+1) + '/' + start.getFullYear(); 
    const time = date;

    const stars = [];

    for (let i = 0; i<review.rating; i++) {
        stars.push(<BsStarFill color="gold"/>)
    }
    for (let i = 5; i>review.rating; i--) {
        stars.push(<BsStar color="gold"/>)
    }

    return (
        <Card className="card my-2">
        {/* <Card.Header className='font-weight-bold'>

        </Card.Header> */}
        <Card.Body>
            {stars}
            <Card.Text className='mt-2'>
                Reviewed on {time} <BsDot className='ml-1 mb-1 mr-1'/> <BsPersonCheck className='mb-1 mr-2'/> Verified patient
            </Card.Text>
            <Card.Text  >
                {review.review}
            </Card.Text>
        </Card.Body>
        </Card>
        );
}

